<template>
  <div class="side-bar">
    <!-- <p class="heading">Company Settings</p> -->
    <router-link
      class="button-sidebar-2"
      to="/profile"
      v-bind:class="{ 'button-sidebar-2-active': page == 'profile' }"
    >
      <img
        src="/images/profile-icons/Account-Profile-Icon.png"
        alt=""
      />
      Profile
    </router-link>
    <router-link
      class="button-sidebar-2"
      to="/company"
      v-bind:class="{ 'button-sidebar-2-active': editingCompany == 'edit' }"
    >
      <img src="/images/profile-icons/Company-Icon.png" alt="" />
      Company
    </router-link>
  </div>
</template>

<script>
import router from "@/router";

export default {
  name: "SideBarProfile",
  data() {
    return {
      // mode: 'login' // login/register
    };
  },
  props: ["page", "editingCompany"],
  components: {},
  methods: {
    goTo(path) {
      router.push(path);
    },
    editCompany() {
      console.log("edit company");
      this.$emit("editCompany");
    }
  },
  computed: {},
  created() {
    // console.log('** Login Component Loaded')
  }
};
</script>

<style scoped lang="scss">
//
// Sidebar
//
.side-bar {
  padding: 40px 20px;
  width: 274px;
  background-color: white;

  // Responsive Style
  // @media max-width: 768px
  @media (max-width: 768px) {
    width: 100%;
    padding-top: 20px;
    padding-bottom: 0px;
  }
}

a {
  margin-bottom: 20px;
  padding-left: 8px;
  text-decoration: none !important;
}
button {
  margin-bottom: 20px;
}

.heading {
  margin-bottom: 20px;
  color: #000000;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.5px;
  line-height: 25px;
}

.button-sidebar-2 {
  cursor: pointer;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -moz-flex-direction: row;
  -ms-flex-direction: row;
  -o-flex-direction: row;
  flex-direction: row;
  -ms-align-items: center;
  align-items: center;
  font-family: "Nexa";
  font-weight: 600;
  font-size: 18px;

  img {
    margin-right: 19px;
    width: 20px;
    height: 20px;
    object-fit: contain;
  }

  // display: none;

  &.button-sidebar-2-active {
    // display: block;
  }
}
</style>
